export default __webpack_public_path__ + "static/media/TAKE-AWAY.ae3e3b3b.svg";